import { crudActions } from "@/services/CrudActions";
import apiClient from "@/services/ApiClient";

export default {
  ...crudActions("product-components"),
  deleteDoorComponent: id => apiClient.post(`/product-components/quitar`, { id: id }),
};
